import { action } from 'typesafe-actions';

import { IReportItem } from 'APIPackage/MainModule/interfaces/IReportItem';

import { ReportsActionsEnum } from '../enums/ReportsActionsEnum';
import { IReportSettingsForm } from '../interfaces/IReportSettingsForm';

interface ICorrectiveOption {
  hasYear: boolean;
  hasMonth: boolean;
  hasProsecutors: boolean;
  hasOrganizations: boolean;
  hasSpecialOrganizationsIncluded: boolean;
  hasFederalLawName: boolean;
  hasPlanNumber: boolean;
  hasPeriod: boolean;
}

export const reportsDownloadExtendedReport = (
  values: IReportSettingsForm,
  activeItem: IReportItem | undefined,
  correctiveOption: ICorrectiveOption,
) => action(ReportsActionsEnum.REPORTS_DOWNLOAD_EXTENDED_REPORT, { values, activeItem, correctiveOption });
